module.exports = __webpack_public_path__ + "static/media/5D.eda01110.svg";